export default "__VITE_ASSET__DMO4EXik__"